
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulation/whatis",
      function () {
        return require("private-next-pages/regulation/whatis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulation/whatis"])
      });
    }
  